export const ourProducts = [
    {
        title: 'Satellite Command and Control Software',
        subtitle: 'Effortlessly manage and control your fleet of satellites with our advanced Satellite Command and Control Software. Ensure optimal performance, execute precise maneuvers, and monitor mission-critical data in real-time.',
        img: 'url(/industries/space-technology/satellite-command-control-software.avif)',
        content: 'Ensure optimal performance, execute precise maneuvers, and monitor mission-critical data in real-time.',
        link: '/industries/aerospace/products/satellite-command-and-control-software'
    },

    {
        title: 'Orbital Dynamics Simulation Tools',
        subtitle: 'Simulate and analyze orbital dynamics with unparalleled precision using our cutting-edge tools. Optimize mission planning, predict trajectories, and navigate the complexities of space with confidence.',
        img: 'url(/industries/space-technology/orbital-dynamics-simulation-tools.avif)',
        content: 'Optimize mission planning, predict trajectories, and navigate the complexities of space with confidence.',
        link: '/industries/aerospace/products/orbital-dynamics-simulation-tools' 
    },

    {
        title: 'Spacecraft Telemetry Analysis Software',
        subtitle: 'Harness the power of data with our Spacecraft Telemetry Analysis Software. Gain real-time insights into your spacecraft\'s performance, troubleshoot issues, and ensure mission success through data-driven decision-making.',
        img: 'url(/industries/space-technology/spacecraft-telemetry-analysis-software.jpg)',
        content: 'Gain real-time insights into your spacecraft\'s performance, troubleshoot issues, and ensure mission success through data-driven decision-making.',
        link: '/industries/aerospace/products/spacecraft-telemetry-analysis-software' 
    },

    {
        title: 'Astronomical Data Processing Applications',
        subtitle: 'Transform raw astronomical data into meaningful insights with our Data Processing Applications. Unlock the secrets of the universe by efficiently processing and analyzing vast datasets, empowering astronomers and researchers.',
        img: 'url(/industries/space-technology/astronomical-data-processing-applications.avif)',
        content: 'Unlock the secrets of the universe by efficiently processing and analyzing vast datasets, empowering astronomers and researchers.',
        link: '/industries/aerospace/products/astronomical-data-processing-applications'
    },


    {
        title: 'Space Mission Planning and Scheduling Software',
        subtitle: 'Streamline your space missions with our Planning and Scheduling Software. Optimize resource allocation, coordinate mission timelines, and ensure seamless execution of complex space exploration endeavors.',
        img: 'url(/industries/space-technology/space-mission-planning-scheduling-software.avif)',
        content: 'Optimize resource allocation, coordinate mission timelines, and ensure seamless execution of complex space exploration endeavors.',
        link: '/industries/aerospace/products/space-mission-planning-scheduling-software'
    },


{
    title: 'Satellite Image Processing and Analysis Tools',
    subtitle: 'Unlock the potential of satellite imagery with our Image Processing and Analysis Tools. Extract valuable information, monitor changes over time, and derive actionable intelligence from high-resolution satellite images.',
    img: 'url(/industries/space-technology/satellite-image-processing-analysis-tools.avif)',
    content: 'Extract valuable information, monitor changes over time, and derive actionable intelligence from high-resolution satellite images.',
    link: '/industries/aerospace/products/satellite-image-processing-analysis-tools'
},

{
    title: 'Deep Space Communication Systems',
    subtitle: 'Enable seamless communication across vast distances with our state-of-the-art Deep Space Communication Systems. Ensure reliable connectivity for your spacecraft, even in the most challenging deep space environments.',
    img: 'url(/industries/space-technology/Deep-space-communication-systems.avif)',
    content: 'Ensure reliable connectivity for your spacecraft, even in the most challenging deep space environments.',
    link: '/industries/aerospace/products/deep-space-communication-systems'
},

{
    title: 'Space Weather Forecasting Software',
    subtitle: 'Mitigate risks and enhance mission planning with our Space Weather Forecasting Software. Stay informed about space weather conditions, allowing you to optimize mission success and protect valuable assets.',
    img: 'url(/industries/space-technology/space-weather-forecasting-software.jpg)',
    content: 'Stay informed about space weather conditions, allowing you to optimize mission success and protect valuable assets.',
    link: '/industries/aerospace/products/space-weather-forecasting-software'
},

{
    title: 'Lunar Exploration Simulation Software',
    subtitle: 'Embark on virtual lunar missions with our Lunar Exploration Simulation Software. Experience the challenges and opportunities of lunar exploration, preparing for future missions to Earth\'s celestial companion.',
    img: 'url(/industries/space-technology/lunar-exploration-simulation-software.avif)',
    content: 'Experience the challenges and opportunities of lunar exploration, preparing for future missions to Earth\'s celestial companion.',
    link: '/industries/aerospace/products/lunar-exploration-simulation-software'
},


{
    title: 'Space-based Earth Observation Platforms',
    subtitle: 'Elevate Earth observation capabilities with our advanced satellite platforms. Capture high-resolution imagery and data, supporting scientific research, environmental monitoring, and disaster management.',
    img: 'url(/industries/space-technology/earth-observation-platforms.avif)',
    content: 'Capture high-resolution imagery and data, supporting scientific research, environmental monitoring, and disaster management.',
    link: '/industries/aerospace/products/earth-observation-platforms'
},

{
    title: 'Rocket Propulsion System Design Software',
    subtitle: 'Optimize the design of rocket propulsion systems with our specialized software. Enhance efficiency, reduce fuel consumption, and achieve breakthroughs in space travel propulsion.',
    img: 'url(/industries/space-technology/rocket-propulsion-design-software.avif)',
    content: 'Enhance efficiency, reduce fuel consumption, and achieve breakthroughs in space travel propulsion.',
    link: '/industries/aerospace/products/rocket-propulsion-design-software'
},

{
    title: 'Autonomous Satellite Navigation Systems',
    subtitle: 'Achieve unprecedented autonomy in satellite navigation with our cutting-edge systems. Ensure precise and adaptive navigation, even in dynamic and challenging space environments.',
    img: 'url(/industries/space-technology/autonomous-satellite-navigation-systems.avif)',
    content: 'Ensure precise and adaptive navigation, even in dynamic and challenging space environments.',
    link: '/industries/aerospace/products/autonomous-satellite-navigation-systems'
},

{
    title: 'Space Debris Tracking and Collision Avoidance Software',
    subtitle: 'Safeguard your satellites and spacecraft with our Space Debris Tracking Software. Monitor space debris in real-time and implement collision avoidance strategies to protect your valuable assets.',
    img: 'url(/industries/space-technology/space-debris-tracking-software.jpg)',
    content: 'Monitor space debris in real-time and implement collision avoidance strategies to protect your valuable assets.',
    link: '/industries/aerospace/products/space-debris-tracking-software'
},

{
    title: 'Microgravity Research Simulation Tools',
    subtitle: 'Conduct groundbreaking microgravity research with our Simulation Tools. Create controlled environments that simulate weightlessness, facilitating experiments and discoveries in a unique space-like setting.',
    img: 'url(/industries/space-technology/microgravity-research-simulation-tools.avif)',
    content: 'Create controlled environments that simulate weightlessness, facilitating experiments and discoveries in a unique space-like setting.',
    link: '/industries/aerospace/products/microgravity-research-simulation-tools'
},


{
    title: 'Astrobiology Research and Data Analysis Software',
    subtitle: 'Contribute to the exploration of life beyond Earth with our Astrobiology Research Software. Analyze data and uncover insights that push the boundaries of our understanding of life\'s potential in the universe.',
    img: 'url(/industries/space-technology/astrobiology-research-software.avif)',
    content: 'Analyze data and uncover insights that push the boundaries of our understanding of life\'s potential in the universe.',
    link: '/industries/aerospace/products/astrobiology-research-software'
},

{
    title: 'Orbital Maneuvering Optimization Software',
    subtitle: 'Optimize orbital maneuvers with precision using our specialized software. Enhance mission efficiency and achieve precise control over spacecraft trajectories for successful space missions.',
    img: 'url(/industries/space-technology/orbital-maneuvering-optimization-software.jpg)',
    content: 'Enhance mission efficiency and achieve precise control over spacecraft trajectories for successful space missions.',
    link: '/industries/aerospace/products/orbital-maneuvering-optimization-software'
},

{
    title: 'Spacecraft Thermal Analysis and Design Tools',
    subtitle: 'Ensure thermal stability in space with our Analysis and Design Tools. Address the complexities of thermal management for spacecraft, optimizing performance in extreme environmental conditions.',
    img: 'url(/industries/space-technology/spacecraft-thermal-analysis-design-tools.avif)',
    content: 'Address the complexities of thermal management for spacecraft, optimizing performance in extreme environmental conditions.',
    link: '/industries/aerospace/products/spacecraft-thermal-analysis-design-tools'
},

{
    title: 'Radiation Shielding Simulation Software',
    subtitle: 'Protect astronauts and equipment from radiation hazards with our Simulation Software. Gain critical insights for effective shielding design, ensuring the safety of personnel and equipment during space missions.',
    img: 'url(/industries/space-technology/radiation-shielding-simulation-software.jpg)',
    content: 'Gain critical insights for effective shielding design, ensuring the safety of personnel and equipment during space missions.',
    link: '/industries/aerospace/products/radiation-shielding-simulation-software'
},

{
    title: 'Planetary GIS Mapping Applications',
    subtitle: 'Map and explore planetary surfaces with our GIS Mapping Applications. Gain detailed insights into the geology and topography of celestial bodies, supporting planetary exploration and research.',
    img: 'url(/industries/space-technology/planetary-gis-mapping-applications.avif)',
    content: 'Gain detailed insights into the geology and topography of celestial bodies, supporting planetary exploration and research.',
    link: '/industries/aerospace/products/planetary-gis-mapping-applications'
},

{
    title: 'Exoplanet Discovery and Characterization Software',
    subtitle: 'Contribute to the forefront of exoplanet research with our specialized software. Enable astronomers to discover and characterize planets beyond our solar system, expanding our understanding of distant planetary systems.',
    img: 'url(/industries/space-technology/exoplanet-discovery-characterization-software.avif)',
    content: 'Enable astronomers to discover and characterize planets beyond our solar system, expanding our understanding of distant planetary systems.',
    link: '/industries/aerospace/products/exoplanet-discovery-characterization-software'
},
]

